var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full flex flex-col"},[_c('Steps',{attrs:{"current":_vm.currentStep}},_vm._l((_vm.steps),function(ref,index){
var titleKey = ref.titleKey;
var descKey = ref.descKey;
return _c('Step',{key:index,attrs:{"title":_vm.$t(titleKey),"content":_vm.$t(descKey)}})}),1),_c(_vm.steps[_vm.currentStep].component,{tag:"component",staticClass:"flex-grow",model:{value:(_vm.stepData),callback:function ($$v) {_vm.stepData=$$v},expression:"stepData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }